import {Injectable, OnDestroy, Renderer2} from "@angular/core";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";
import {Subject, Subscription} from "rxjs";

@Injectable({ providedIn: 'root' })
export class BodyStyleService implements OnDestroy {
  private setStyle$ = new Subject<{styleName: string, styleData: string}>();
  private routerSub: Subscription;
  setStyle = this.setStyle$.asObservable();

  constructor(private router: Router) {}

  init() {
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateBodyClassBasedOnRoute(event.url);
      });
  }

  private updateBodyClassBasedOnRoute(url: string) {
    // Добавляем нужный стиль в зависимости от маршрута
    if (url.startsWith('/login')) {
      this.setStyle$.next({styleName: 'background-color', styleData: '#ffffff'});
    } else {
      this.setStyle$.next({styleName: 'background-color', styleData: '#EEEEEE'});
    }
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }
}
